import React, { useEffect, useState } from 'react';
import { Button, Message } from 'semantic-ui-react';
import { API } from '../helpers';

export default function LogArchivePanelV119({ language }) {
  const en = String(language).startsWith('en');
  const text = (zh, english) => en ? english : zh;
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState(null);
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState('');
  const [completed, setCompleted] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open || !status?.running) return;
    const timer = window.setTimeout(load, 2000);
    return () => window.clearTimeout(timer);
    // Poll only while this panel is open and a server job is running.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, status]);
  const load = async () => {
    setBusy(true); setError('');
    try {
      const response = await API.get('/api/log/archive/status');
      if (!response.data?.success) throw new Error(response.data?.message || 'Archive status unavailable');
      setStatus(response.data.data);
    } catch (e) { setError(e.message); } finally { setBusy(false); }
  };
  const run = async (dryRun) => {
    setBusy(true); setError(''); setCompleted(false);
    try {
      const response = await API.post('/api/log/archive/run', { dry_run: dryRun, background: !dryRun });
      if (!response.data?.success) throw new Error(response.data?.message || 'Archive maintenance failed');
      setPreview(dryRun ? response.data.data : null);
      if (!dryRun) { setCompleted(response.data.data?.running !== true); await load(); }
    } catch (e) { setError(e.message); } finally { setBusy(false); }
  };
  return (
    <details className='log-archive-panel-v119' onToggle={(e) => {
      setOpen(e.currentTarget.open);
      if (e.currentTarget.open && !busy) load();
    }}>
      <summary>{text('历史日志归档管理', 'Historical log archive management')}</summary>
      <p>{text('按整月归档，在线至少保留60天。先核验复制内容，再移出主库并压缩；账务流水和余额不变。执行前请确认数据库与归档目录已有可用备份。', 'Archive complete months, retaining at least 60 days online. Copies are verified before removal and compression; ledger and balances remain unchanged. Ensure a usable backup of the database and archive directory before running.')}</p>
      {status && <p>{text('已有归档月份：', 'Archived months: ')}{status.archive_count} · {text('自动归档：', 'Automatic maintenance: ')}{status.enabled ? text('已启用', 'Enabled') : text('未启用', 'Disabled')}</p>}
      {status?.running && <Message info role='status'>{text('后台正在归档，可以关闭页面；稍后展开此处查看结果。', 'Archiving in the background. You can close this page and return to check the result.')}</Message>}
      {!status?.running && status?.last_error && <Message negative role='alert'>{text('上次归档未完成，可核查后重试：', 'Previous archive run incomplete; review and retry: ')}{status.last_error}</Message>}
      {!status?.running && status?.last_completed_at > 0 && !status?.last_error && <p>{text('上次归档完成：', 'Last archive completed: ')}{new Date(status.last_completed_at * 1000).toLocaleString()}</p>}
      {error && <Message negative role='alert'>{error}</Message>}
      {preview && <Message info>{text('待归档记录：', 'Eligible records: ')}{preview.eligible_rows} · {text('月份：', 'Months: ')}{preview.candidate_periods?.join(', ') || '—'}<br />{text('执行时也会压缩已完成的旧归档。', 'Existing completed archives are also compressed.')}</Message>}
      {completed && <Message positive role='status'>{text('归档与压缩已完成。', 'Archiving and compression completed.')}</Message>}
      <Button size='small' type='button' loading={busy} disabled={busy || status?.supported !== true || status?.running} onClick={() => run(true)}>{text('预览归档', 'Preview archive')}</Button>
      {preview && <Button size='small' type='button' disabled={busy} onClick={() => run(false)}>{text('已确认备份，执行归档并压缩', 'Backup confirmed — archive and compress')}</Button>}
    </details>
  );
}
